import { Flex, Provider as MosaicProvider, useIconStore } from '@stoplight/mosaic';
import React from 'react';

import { ElementsAPI } from './components/ElementsAPI';

export function App() {
  const setDefaultStyle = useIconStore(state => state.setDefaultStyle);

  React.useEffect(() => {
    setDefaultStyle('fas');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MosaicProvider>
      <Flex direction="col" bg="canvas" h="screen">
        <ElementsAPI />
      </Flex>
    </MosaicProvider>
  );
}
